import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import DrawCollection from './draw-collection';
import DrawModel from './draw-model';
import WinnerModel from './winner-model';
import WinnerHistoryCollection from './winner-history-collection';

function fetchDraws(experienceId) {
  return ajaxService.helios
    .get(
      'winner/list',
      {
        campaignId:         experienceId,
        includeInvalidated: true,
        offset:             0,
      },
      { cache: false }
    )
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(DrawCollection.deserialize)
    .catch((error) => ({ error }));
}

function fetchWinnersHistory(experienceId) {
  return ajaxService.helios
    .get(
      'winner/history',
      {
        campaignId:   experienceId,
        listReserves: false,
      },
      { cache: false }
    )
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(WinnerHistoryCollection.deserialize)
    .catch((error) => ({ error }));
}

function shuffleDraw(id) {
  return ajaxService.helios
    .post('winner/shuffle', {
      drawId: id,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(DrawModel.deserialize)
    .catch((error) => ({ error }));
}

function reselectDraw(id) {
  return ajaxService.helios
    .get('winner/fill', {
      drawId: id,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(DrawModel.deserialize)
    .catch((error) => ({ error }));
}

function invalidateWinner(id) {
  return ajaxService.helios
    .post('winner/invalidatePlace', {
      placeId: id,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(WinnerModel.deserialize)
    .catch((error) => ({ error }));
}

function validateWinner(id) {
  return ajaxService.helios
    .post('winner/uninvalidatePlace', {
      placeId: id,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(WinnerModel.deserialize)
    .catch((error) => ({ error }));
}

function reselectWinner(id) {
  return ajaxService.helios
    .post('winner/switchPlace', {
      placeId: id,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(WinnerModel.deserialize)
    .catch((error) => ({ error }));
}

export default {
  fetchDraws,
  fetchWinnersHistory,
  shuffleDraw,
  reselectDraw,
  invalidateWinner,
  validateWinner,
  reselectWinner,
};
